import { Reducer } from "redux";
import { ITranslationState, TranslationActions, TranslationActionTypes } from "./types";
import i18n from "i18next";

const initialLanguage = i18n.language?.substring(0, 2) || "en";

const initialState: ITranslationState = {
  language: initialLanguage
};
document.dir = i18n.dir(initialLanguage);

export const translationReducer: Reducer<ITranslationState, TranslationActions> = (state = initialState, action) => {
  switch (action.type) {
    case TranslationActionTypes.SET_LANGUAGE: {
      const language = action.payload;

      return {
        language
      };
    }
    default:
      return state;
  }
};
